var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainImage"},[_c('img',{attrs:{"src":"https://grupo-cayman.com/wp-content/uploads/2022/09/logo_benelli_land.png"}})])
}]

export { render, staticRenderFns }